// components/UI/SearchInput.js

import React from 'react';
import { useTranslation } from '../../context/I18nContext';

// placeholder has no default value here on purpose — undefined is how this
// component tells "the caller didn't ask for specific text" apart from
// "the caller explicitly wants literal English 'Search...'", so it can
// fall back to the translated common.search_placeholder only in the first
// case (see resolvedPlaceholder below).
const SearchInput = ({ value, onChange, placeholder, className = "" }) => {
  const { t } = useTranslation('common');
  const resolvedPlaceholder = placeholder || t("search_placeholder", "Search...");

  const handleClear = () => {
    onChange(""); // إرسال قيمة فارغة للأب
  };

  return (
    <div className={`flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto ${className}`}>
      <div style={{ position: 'relative', width: '100%', maxWidth: '320px' }}>
        
        {/* أيقونة البحث — insetInlineStart بدل left عشان تتقلب تلقائي مع
            اتجاه اللغة (rtl للعربي) */}
        <span style={{
          position: 'absolute',
          insetInlineStart: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 10,
          pointerEvents: 'none',
          fontSize: '14px'
        }}>
          🔍
        </span>

        <input
          type="text"
          placeholder={resolvedPlaceholder}
          className="login-input !mb-0"
          style={{
            width: '100%',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingInlineStart: '40px',
            paddingInlineEnd: '40px',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            backgroundColor: '#f9fafb',
            fontSize: '14px'
          }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />

        {/* زر المسح الذكي — insetInlineEnd بدل right لنفس السبب */}
        {value && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              position: 'absolute',
              insetInlineEnd: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '22px',
              height: '22px',
              backgroundColor: '#e2e8f0',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'none',
              cursor: 'pointer',
              fontSize: '10px',
              fontWeight: 'bold',
              color: '#64748b',
              zIndex: 20,
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#fee2e2';
              e.target.style.color = '#ef4444';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#e2e8f0';
              e.target.style.color = '#64748b';
            }}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;